import dynamic from 'next/dynamic';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { closeLoginModal } from '@/store/reducers/loginModal';
import { useLenis } from "lenis/react";
import CookieConsentDrawer from '@/components/ui/CookieConsentDrawer';
import Script from 'next/script';

interface FilterDetails {
  propertyTypes?: Set<string>;
  highlights?: Set<string>;
  amenities?: Set<string>;
  bedTypes?: Set<string>;
}

interface RootState {
  loginModal: {
    loginModal: boolean
    modalType: 'login' | 'register'
  }
  filters: FilterDetails;
}

export default function LayoutContent({ children, isMobile }: { children: React.ReactNode, isMobile: boolean }) {
  const AuthModal = dynamic(() => import('@/components/auth/AuthModal'), { ssr: false });
  const Toaster = dynamic(() => import('@/components/ui/toaster').then(mod => mod.Toaster), { ssr: false });
  const dispatch = useDispatch();
  const lenis = !isMobile ? useLenis() : null;
  const isLoginModalOpen = useSelector((state: RootState) => state.loginModal.loginModal);
  const authModalType = useSelector((state: RootState) => state.loginModal.modalType);

  const closeModal = useCallback((open: boolean) => {
    if (!open && !isMobile) {
      lenis?.start();
    }

    if (!isLoginModalOpen) return;
    dispatch(closeLoginModal());
  }, [dispatch, isLoginModalOpen, lenis, isMobile]);


  const token = process.env.NEXT_PUBLIC_ACCESSIBILITY_TOKEN ?? 'default-fallback-token';

  return (
    <>
      {children}
      <Toaster />
      <AuthModal isOpen={isLoginModalOpen} onOpenChange={closeModal} activeTab={authModalType || 'login'} />
      <CookieConsentDrawer />
      <Script id="aioa-loader" strategy="afterInteractive">
        {`
          setTimeout(() => {
            let aioa_script_tag = document.createElement("script");
            aioa_script_tag.src = "https://www.skynettechnologies.com/accessibility/js/all-in-one-accessibility-js-widget-minify.js?colorcode=#ef5a60&token=${token}&position=bottom_right";
            aioa_script_tag.id = "aioa-adawidget";
            aioa_script_tag.defer = true;
            document.getElementsByTagName("body")[0].appendChild(aioa_script_tag);
          }, 3000);
        `}
      </Script>
    </>
  );
}
